<template>
    <div class="operand-simple">
        <compare-selector
            ref="selector"
            :value="selectorValue"
            :type="selectorType"
            :placeholder="selectorPlaceholder"
            @change="onConditionSelectorChange"
        />
        <v-number-input
            v-if="inputType === 'number'"
            :only-integer="true"
            :value="startValue"
            default=""
            :class="{
                'input-invalid': !valid
            }"
            @change="onStartChange"
        />
        <v-input
            v-if="inputType === 'input'"
            :value="startValue"
            kind="simpler"
            :reg="reg"
            :class="{
                long: selectorType === 'LOGIC',
                'input-invalid': !valid
            }"
            :placeholder="inputPlaceholder"
            @change="onStartChange"
        />
        <v-date-picker
            v-if="inputType === 'date'"
            v-model="dateValue"
            class="operand-simple__date-picker"
            :class="{
                'trigger-invalid': !valid,
                'operand-simple__date-picker--placeholder': dateValue.length === 0
            }"
            :kind="checkRange ? 'DateRangePanel' : 'DatePanel'"
            display-format="YYYY-MM-DD"
            :placeholder="checkRange ? inputPlaceholder + '区间' : inputPlaceholder"
            @confirm="onStartChange"
        />
        <span class="input-unit">{{ inputUnit }}</span>
        <template v-if="checkRange && ['input', 'number'].indexOf(inputType) > -1">
            <span class="range-hr">{{ rangeHr }}</span>
            <v-number-input
                v-if="inputType === 'number'"
                :only-integer="true"
                :value="endValue"
                :class="{
                    'input-invalid': !valid2
                }"
                default=""
                @change="onEndChange"
            />
            <v-input
                v-else
                :value="endValue"
                kind="simpler"
                :placeholder="inputPlaceholder"
                :reg="reg"
                :class="{
                    'input-invalid': !valid2
                }"
                @change="onEndChange"
            />
            <span class="input-unit">{{ inputUnit }}</span>
        </template>
    </div>
</template>

<script>
import moment from 'moment';
import CompareSelector from '../plugins/compare-selector';

export default {
  name: 'CompareValue',

  components: {
    CompareSelector,
  },

  props: {
    valid2: {
      type: Boolean,
      default: true,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    reg: {
      type: RegExp,
      default() {
        return null;
      },
    },
    value: {
      type: [Number, String, Array, Object],
      default() {
        return null;
      },
    },
    selectorPlaceholder: {
      type: String,
      default: '请选择条件',
    },
    inputPlaceholder: {
      type: String,
      default: '填写内容',
    },
    inputType: {
      type: String,
      default: 'input',
    },
    inputUnit: {
      type: String,
      default: '单位',
    },
    selectorType: {
      type: String,
      default: 'COMPARE',
    },
  },

  data() {
    let selectorValue = null;
    if (this.value) {
      selectorValue = this.value.operand;
    }
    return {
      selectorValue,
      startValue: this.value.startValue,
      endValue: this.value.endValue,
      dateValue: [],
      range: false,
      rangeHr: '至',
    };
  },

  computed: {
    checkRange() {
      let between =                (this.selectorType === 'TIME_POINT' || this.selectorType === 'TIME_POINT_SIMPLE')
                && this.selectorValue === 'between';
      if (!between) {
        between = this.selectorType === 'COMPARE' && this.selectorValue === 'between';
      }
      return between;
    },
  },

  watch: {
    value(newValue) {
      if (newValue) {
        this.selectorValue = newValue.operand;
        this.inputValue = newValue.value;
      }
    },
  },

  mounted() {
    this.init();
    this.onChange();
  },

  methods: {
    init() {
      const value = this.value || {};
      if (this.value.value || this.value.value === 0) {
        // 否则为0的情况无法执行
        if (this.inputType === 'date') {
          this.dateValue = [
            moment(value.value.startValue).format('YYYY-MM-DD'),
            moment(value.value.endValue).format('YYYY-MM-DD'),
          ];
        }
        if (this.checkRange) {
          this.startValue = value.value.startValue;
          this.endValue = value.value.endValue;
        } else {
          this.startValue = typeof value.value !== 'object' ? value.value : value.value.startValue;
          this.endValue = typeof value.value !== 'object' ? value.value : value.value.endValue;
          // 原来这种写法如果value是0的话永远也无法成功赋值
          // this.startValue = value.value || value.value.startValue;
        }
      } else if (this.inputType === 'date') {
        this.dateValue = [];
      } else {
        this.startValue = '';
        this.endValue = '';
      }
    },
    onSelectItemTime(ref) {
      this.$refs.timeSelectPopper.bindTrigger(ref.target);
      this.$refs.timeSelectPopper.update();
      this.$refs.timeSelectPopper.show();
    },
    onConditionSelectorChange(value) {
      this.selectorValue = value;
      this.onChange();
    },
    onStartChange(value) {
      if (this.inputType === 'date') {
        this.startValue = +new Date(value[0].toString());
        this.endValue = +new Date(value[1].toString());
      } else {
        this.startValue = value;
      }
      this.onChange();
    },
    onEndChange(value) {
      this.endValue = value;
      this.onChange();
    },
    onChange() {
      this.$emit('change', {
        operand: this.selectorValue,
        value: this.computedValue(),
      });
    },
    tryInt(val) {
      const ret = parseInt(val, 10);
      return Number.isNaN(ret) ? val : ret;
    },
    computedValue() {
      let value;
      if (this.checkRange || this.inputType === 'date') {
        switch (this.selectorType) {
        case 'COMPARE':
          value = {
            startValue: this.tryInt(this.startValue),
            endValue: this.tryInt(this.endValue),
          };
          break;
        default:
          value = {
            startValue: this.startValue,
            endValue: this.endValue,
          };
        }
      } else {
        switch (this.selectorType) {
        case 'COMPARE':
          value = this.tryInt(this.startValue);
          break;
        default:
          value = this.startValue;
        }
      }
      return value;
    },
  },
};
</script>
